const dayjs = require("dayjs");

export const getTimeFromNow = t => {
  const time = dayjs(t);
  return time.fromNow();
};
